export const getProratedPrice = (periodStart: Date, periodEnd: Date, prorationDate: Date, price: number) => {
  const secondsInPeriod = (periodEnd.getTime() - periodStart.getTime()) / 1000
  const secondsInProration =
    periodEnd > prorationDate
      ? (periodEnd.getTime() - prorationDate.getTime()) / 1000
      : (periodEnd.getTime() + secondsInPeriod * 1000 - prorationDate.getTime()) / 1000
  return (price * secondsInProration) / secondsInPeriod
}

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export const formatPrice = (price: number) => USD_FORMATTER.format(price)

const TWO_WEEKS = 14
export const getReminderDay = (deltaTrialDays: number) => Math.max(1, deltaTrialDays - TWO_WEEKS)

export const formatProratedPrice = (proratedPrice: number | null) => (proratedPrice ? formatPrice(proratedPrice) : 'Unknown')
